module.exports = __webpack_public_path__ + "img/ms_word.245025e2.jpeg";